"use client";

import { ArrowUp } from "lucide-react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useScrollContext } from "@/components/motion/SmoothScrollProvider";
import { useNearFooter } from "@/hooks/useNearFooter";

const SHOW_AFTER_SCROLL = 600;

export function FloatingBackToTop() {
  const { scrollY, scrollToTop } = useScrollContext();
  const nearFooter = useNearFooter(scrollY);
  const reduced = useReducedMotion();

  const isVisible = scrollY > SHOW_AFTER_SCROLL && !nearFooter;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={reduced ? false : { opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduced ? undefined : { opacity: 0, y: 16 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-[max(1.5rem,env(safe-area-inset-bottom))] left-4 z-40 max-sm:left-3"
        >
          <button
            type="button"
            onClick={scrollToTop}
            className="floating-back-to-top flex h-11 w-11 items-center justify-center rounded-full border border-border bg-card text-muted shadow-lg transition-colors hover:border-accent hover:bg-accent/10 hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background"
            aria-label="Back to top"
          >
            <ArrowUp size={18} aria-hidden />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
